import React, { forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

import { cn } from '../../../shared/cn';
import type { InputProps, InputSize } from '../Input.types';

const sizeClasses: Record<InputSize, string> = {
  small: 'tw-field--sm',
  middle: 'tw-field--md',
  large: 'tw-field--lg',
};

const base = 'tw-field tw-focus w-full disabled:opacity-60 disabled:cursor-not-allowed';

export const Input = forwardRef<HTMLInputElement, InputProps>(({ size = 'middle', error = false, className, ...props }, ref) => {
  const classes = twMerge(cn(base, sizeClasses[size], error && 'tw-field--error'), className);

  return <input ref={ref} className={classes} aria-invalid={error || undefined} {...props} />;
});

Input.displayName = 'Input';
